<template>
  <div>
    <div class="header">
      <div class="header_content">
        <!-- header -->
        <div class="content">
          <h4>我的案件统计</h4>
          <div class="title">我所参与案件及投入工时累计</div>
          <div class="box">
            <div class="box_time">
              <div class="left">
                <span class="time">{{ myHouser.hour }}</span>
                <span class="tipx">累计投入工时</span>
              </div>
              <div class="line"></div>
              <div class="right">
                <span class="time">{{ myHouser.count }}</span>
                <span class="tipx">当前参与案件数</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="caseBox">
      <van-pull-refresh v-model="state.refreshing" @refresh="onRefresh">
        <van-list
          style="height: calc(100% - 200px)"
          :loading="state.loading"
          :finished="state.finished"
          :offset="50"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <template v-for="item in state.list" :key="item">
            <ActiveList
              :nav="`
              ${item.finalCustomer}
              /${item.caseType}/${item.time.split(' ')[0]}/${item.caseStatusName}`"
              :title="item.caseName"
              :time="item.countHour"
              @click="onJump(item.id)"
            ></ActiveList>
          </template>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, reactive, ref } from 'vue';
import ActiveList from '@/components/ActiveList.vue';
import { List, PullRefresh } from 'vant';
import { useRouter } from 'vue-router';
import { getMyCaseInfo } from '@/http/home';
import getList from '@/http/castList';

export default defineComponent({
  components: {
    ActiveList,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
  },
  setup() {
    // console.log(this);
    const router = useRouter();
    const state = reactive({
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
    });
    const myHouser = ref({});
    getMyCaseInfo().then((res: any) => {
      myHouser.value = res.result;
    });
    const onJump = (id: string) => {
      router.push({
        path: '/caseInfo',
        query: { projectid: id },
      });
    };
    const pages = reactive({
      pageNo: 0,
      pageSize: 6,
    });
    const onLoad = () => {
      console.log('11');
      state.loading = true;
      pages.pageNo += 1;
      state.finished = false;
      console.log('112');
      getList(pages).then((res: any) => {
        console.log(66);
        const { total } = res.result;
        const data: [] = res.result.records;
        state.refreshing = false;
        state.list.push(...data);
        state.loading = false;
        console.log(state.list.length);
        console.log(total);
        if (state.list.length === total) {
          state.finished = true;
        }
      });
    };
    const onRefresh = () => {
      state.list = [];
      pages.pageNo = 0;
      onLoad();
    };
    return {
      state,
      onLoad,
      onJump,
      myHouser,
      onRefresh,
    };
  },
});
</script>

<style lang="scss" scoped>
.header {
  height: 240px;
  .header_content {
    background: #5374e8;
    height: 170px;
    position: relative;
    .content {
      position: absolute;
      margin: auto;
      left: 0;
      right: 0;
      top: 30px;
      h4 {
        width: 320px;
        font-size: 20px;
        margin: auto;
        color: #fff;
      }
      .title {
        font-size: 12px;
        color: #fff;
        width: 320px;
        margin: 10px auto;
      }
      .box {
        width: calc(100% - 40px);
        height: 80px;
        background: #fff;
        border-radius: 11px;
        margin: auto;
        margin-top: 30px;
        padding: 10px;
        .box_time {
          display: flex;
          align-items: center;
          .line {
            width: 1px;
            height: 50px;
            background: #d2d2d2;
          }
          .left,
          .right {
            display: flex;
            flex-direction: column;
            flex: 1;
            text-align: center;
            .time {
              font-size: 40px;
              font-weight: bold;
            }
            .tipx {
              font-size: 12px;
              color: #767676;
            }
          }
        }
        .box_line {
          height: 1px;
          background: #ddd;
          margin: 20px;
        }
        .box_notie {
          font-size: 14px;
          text-align: center;
          color: #747474;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
}
.caseBox {
  padding: 0 10px;
  height: calc(100vh - 290px);
  overflow: auto;
}
</style>
